import { render, staticRenderFns } from "./ProposalsTab.vue?vue&type=template&id=07f309aa&scoped=true&"
import script from "./ProposalsTab.vue?vue&type=script&lang=js&"
export * from "./ProposalsTab.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsTab.vue?vue&type=style&index=0&id=07f309aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f309aa",
  null
  
)

export default component.exports